var _style, _g, _path, _path2, _path3, _path4, _polygon, _polygon2, _polygon3, _polygon4, _path5, _path6, _path7, _path8, _path9, _line, _path10, _line2, _line3, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _circle, _circle2, _ellipse, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _g2, _g3, _g4, _g5, _g6, _g7, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _polygon5, _path19, _line21, _line22, _line23, _line24, _line25, _line26, _path20, _line27, _path21, _path22;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHgv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 576.5 141.1",
    style: {
      enableBackground: "new 0 0 576.5 141.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;stroke:#154863;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st1{fill:#EAEFF9;}\r\n\t.st2{fill:#CCD9ED;}\r\n\t.st3{fill:none;stroke:#0F324F;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st4{fill:#FFFFFF;stroke:#154863;stroke-width:1.5;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st5{fill:none;stroke:#154863;stroke-width:1.5;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st6{fill:none;stroke:#0F324F;stroke-width:1.5;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st7{fill:#EAEFF9;stroke:#0F324F;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st8{fill:#FFFFFF;stroke:#0F324F;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st9{fill:#EAEFF9;stroke:#0F324F;stroke-width:1.5;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st10{fill:#90AED5;stroke:#0F324F;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st11{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M533.2,27c-5.7-5.3-17.6-13.5-39-17.4c-0.8-0.1-1.5,0.2-1.9,0.8l-2.8,5.5c-1.8,3.5-5.2,8.6-5.1,13.6l49.7-0.1 C534.2,28.6,534,27.7,533.2,27L533.2,27z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2,0.8h471c0.7,0,1.2,0.5,1.2,1.2v96.3c0,0.7-0.5,1.2-1.2,1.2H2c-0.7,0-1.2-0.5-1.2-1.2V2 C0.8,1.3,1.3,0.8,2,0.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M286.7,112v12.2c0,1.3-1,2.3-2.3,2.3H29c-1.3,0-2.3-1-2.3-2.3V112H6.1c-1.3,0-2.3-1-2.3-2.3V99.5h335.3 l-45.4,11.4C291.4,111.4,289.1,111.8,286.7,112L286.7,112L286.7,112z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M573.3,103.1v22c0,0.8-0.6,1.4-1.4,1.4H343.3c-0.8,0-1.4-0.6-1.4-1.4v-5.8c0-0.8-0.6-1.4-1.4-1.4l0,0 c-0.8,0-1.4-0.6-1.4-1.4v-5.3c0-0.6,0.4-1.2,1.1-1.4l16.5-4.2c0.1,0,0.2,0,0.4,0h138.5c0.8,0,1.4-0.6,1.4-1.4v-2.6 c0-0.2,0-0.4-0.1-0.6l-3.8-8.6c-0.4-0.9,0.3-2,1.3-2h77.6c0.8,0,1.4,0.6,1.4,1.4L573.3,103.1L573.3,103.1z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "469.8,99.3 277.9,99.3 377,0.2 469,0.8 469,0.8 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "347.5,0.8 248.9,99.5 150,99.5 248.8,0.8 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "220.7,0.8 122,99.5 72.5,99.5 171.4,0.6 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "573.3,112 338.7,112 339.5,110.2 357,105.5 496.5,105.5 496.9,101.5 493.7,93.8 536.8,93.8  547.3,103.1 573.3,103.1 "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M286.7,112L6,112c-1.2,0-2.3-1-2.3-2.3V99.5h335.3L286.7,112L286.7,112z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M573.3,103.1v22c0,0.8-0.6,1.4-1.4,1.4H343.3c-0.8,0-1.4-0.6-1.4-1.4v-5.8c0-0.8-0.6-1.4-1.4-1.4l0,0 c-0.8,0-1.4-0.6-1.4-1.4v-5.3c0-0.6,0.4-1.2,1.1-1.4l16.5-4.2c0.1,0,0.2,0,0.4,0h138.5c0.8,0,1.4-0.6,1.4-1.4v-2.6 c0-0.2,0-0.4-0.1-0.6l-3.8-8.6c-0.4-0.9,0.3-2,1.3-2h77.6c0.8,0,1.4,0.6,1.4,1.4L573.3,103.1L573.3,103.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M493.7,93.8h-7.9c-0.8,0-1.4-0.6-1.4-1.4v-63h60.9c0.2,0,0.4,0,0.6,0.2l25.7,13.2c0.4,0.2,0.7,0.6,0.8,1.1 l3.4,28.8c0,0.1,0,0.1,0,0.2v28.8c0,0.8-0.6,1.4-1.4,1.4h-27c-0.4,0-0.7-0.2-1-0.4l-8.5-8.5c-0.3-0.3-0.6-0.4-1-0.4h-30.5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M493.7,93.8h-7.9c-0.8,0-1.4-0.6-1.4-1.4v-63h60.9c0.2,0,0.4,0,0.6,0.2l25.7,13.2c0.4,0.2,0.7,0.6,0.8,1.1 l3.4,28.8c0,0.1,0,0.1,0,0.2v28.8c0,0.8-0.6,1.4-1.4,1.4h-27c-0.4,0-0.7-0.2-1-0.4l-8.5-8.5c-0.3-0.3-0.6-0.4-1-0.4h-30.5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M286.7,112v12.2c0,1.3-1,2.3-2.3,2.3H29c-1.3,0-2.3-1-2.3-2.3V112H6.1c-1.3,0-2.3-1-2.3-2.3V99.5h335.3 l-45.4,11.4C291.4,111.4,289.1,111.8,286.7,112L286.7,112L286.7,112z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 52.4,
    y1: 112.2,
    x2: 260.8,
    y2: 112
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M575.7,72.8l-10.1-3.5c-0.6-0.2-0.9-0.7-0.9-1.3V45.9c0-0.8,0.6-1.4,1.4-1.4h6.3"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 271.2,
    y1: 112,
    x2: 286.6,
    y2: 112
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 26.5,
    y1: 112,
    x2: 41.9,
    y2: 112
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M386.4,123.1c0.7,0,1.2-0.6,1.2-1.2c-0.6-10.9-9.7-19.6-20.7-19.6s-20.1,8.7-20.7,19.6c0,0.7,0.5,1.2,1.2,1.2 H386.4L386.4,123.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M539.3,65.1l-7-1c-0.7-0.1-1.2-0.7-1.2-1.4v-19c0-0.8,0.6-1.4,1.4-1.4h24.2c0.8,0,1.4,0.6,1.4,1.4v22.5 c0,0.9-0.8,1.5-1.6,1.4l-11.9-1.7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M433.5,123.1c0.7,0,1.2-0.6,1.2-1.2c-0.6-10.9-9.7-19.6-20.7-19.6s-20.1,8.7-20.7,19.6c0,0.7,0.5,1.2,1.2,1.2 H433.5L433.5,123.1z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M544.2,123.1c0.7,0,1.2-0.6,1.2-1.2c-0.6-10.9-9.7-19.6-20.7-19.6s-20.1,8.7-20.7,19.6c0,0.7,0.5,1.2,1.2,1.2 H544.2L544.2,123.1z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M115.3,123.1c0.7,0,1.2-0.6,1.2-1.2c-0.6-10.9-9.7-19.6-20.7-19.6s-20.1,8.7-20.7,19.6c0,0.7,0.5,1.2,1.2,1.2 H115.3L115.3,123.1z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M157.1,123.1c0.7,0,1.2-0.6,1.2-1.2c-0.6-10.9-9.7-19.6-20.7-19.6s-20.1,8.7-20.7,19.6c0,0.7,0.5,1.2,1.2,1.2 H157.1L157.1,123.1z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M198.8,123.1c0.7,0,1.2-0.6,1.2-1.2c-0.6-10.9-9.7-19.6-20.7-19.6s-20.1,8.7-20.7,19.6c0,0.7,0.5,1.2,1.2,1.2 H198.8L198.8,123.1z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M440.7,109.2h33.3c1.1,0,2,0.9,2,2v15.6c0,1.1-0.9,2-2,2h-33.3c-1.1,0-2-0.9-2-2v-15.6 C438.7,110,439.6,109.2,440.7,109.2z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 414,
    cy: 123.1,
    r: 17.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 366.9,
    cy: 123.1,
    r: 17.3
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3827 -0.9239 0.9239 0.3827 210.1701 560.6619)",
    className: "st10",
    cx: 524.6,
    cy: 123.1,
    rx: 17.3,
    ry: 17.3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 179.2,
    cy: 123.1,
    r: 17.3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 137.5,
    cy: 123.1,
    r: 17.3
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 95.8,
    cy: 123.1,
    r: 17.3
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 366.9,
    cy: 123.1,
    r: 10.8
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 414,
    cy: 123.1,
    r: 10.8
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 524.6,
    cy: 123.1,
    r: 10.8
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 137.5,
    cy: 123.1,
    r: 10.8
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 179.2,
    cy: 123.1,
    r: 10.8
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 95.8,
    cy: 123.1,
    r: 10.8
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M86.2,128.1c1.8,3.5,5.4,5.8,9.6,5.8s7.8-2.4,9.6-5.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M105.4,118c-1.8-3.5-5.4-5.8-9.6-5.8s-7.7,2.3-9.5,5.7"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M127.9,128.1c1.8,3.5,5.4,5.8,9.6,5.8s7.8-2.4,9.6-5.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M147.1,118c-1.8-3.5-5.4-5.8-9.6-5.8c-4.1,0-7.7,2.3-9.5,5.7"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M169.6,128.1c1.8,3.5,5.4,5.8,9.6,5.8s7.8-2.4,9.6-5.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M188.8,118c-1.8-3.5-5.4-5.8-9.6-5.8s-7.7,2.3-9.5,5.7"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M357.2,128.1c1.8,3.5,5.4,5.8,9.6,5.8s7.8-2.4,9.6-5.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M376.5,118c-1.8-3.5-5.4-5.8-9.6-5.8c-4.1,0-7.7,2.3-9.5,5.7"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M404.4,128.1c1.8,3.5,5.4,5.8,9.6,5.8s7.8-2.4,9.6-5.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M423.6,118c-1.8-3.5-5.4-5.8-9.6-5.8s-7.7,2.3-9.5,5.7"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M515,128.1c1.8,3.5,5.4,5.8,9.6,5.8s7.8-2.4,9.6-5.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M534.2,118c-1.8-3.5-5.4-5.8-9.6-5.8s-7.7,2.3-9.5,5.7"
  }))), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 366.9,
    cy: 123.1,
    r: 6.9
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 414,
    cy: 123.1,
    r: 6.9
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 524.6,
    cy: 123.1,
    r: 6.8
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 137.5,
    cy: 123.1,
    r: 6.9
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 179.2,
    cy: 123.1,
    r: 6.9
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 95.8,
    cy: 123.1,
    r: 6.9
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 31.6,
    y1: 87,
    x2: 31.6,
    y2: 99.3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 57.3,
    y1: 87,
    x2: 57.3,
    y2: 99.3
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 83.1,
    y1: 87,
    x2: 83.1,
    y2: 99.3
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 108.8,
    y1: 87,
    x2: 108.8,
    y2: 99.3
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 134.5,
    y1: 87,
    x2: 134.5,
    y2: 99.3
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 160.3,
    y1: 87,
    x2: 160.3,
    y2: 99.3
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 186,
    y1: 87,
    x2: 186,
    y2: 99.3
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 211.7,
    y1: 87,
    x2: 211.7,
    y2: 99.3
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 237.5,
    y1: 87,
    x2: 237.5,
    y2: 99.3
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 263.2,
    y1: 87,
    x2: 263.2,
    y2: 99.3
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 288.9,
    y1: 87,
    x2: 288.9,
    y2: 99.3
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 314.7,
    y1: 87,
    x2: 314.7,
    y2: 99.3
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 340.4,
    y1: 87,
    x2: 340.4,
    y2: 99.3
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 366.1,
    y1: 87,
    x2: 366.1,
    y2: 99.3
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 391.9,
    y1: 87,
    x2: 391.9,
    y2: 99.3
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 417.6,
    y1: 87,
    x2: 417.6,
    y2: 99.3
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 443.3,
    y1: 87,
    x2: 443.3,
    y2: 99.3
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "284.5,13 0.7,13.1 0.7,0.6 474.2,0.8 474.2,13.1 "
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2,0.8h471c0.7,0,1.2,0.5,1.2,1.2v96.3c0,0.7-0.5,1.2-1.2,1.2H2c-0.7,0-1.2-0.5-1.2-1.2V2 C0.8,1.3,1.3,0.8,2,0.8z"
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 5.8,
    y1: 0.8,
    x2: 5.8,
    y2: 99.5
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 469,
    y1: 0.8,
    x2: 469,
    y2: 99.5
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 564.7,
    y1: 112,
    x2: 548.1,
    y2: 112
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 564.7,
    y1: 118.9,
    x2: 550.8,
    y2: 118.9
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 446.8,
    y1: 112,
    x2: 446.8,
    y2: 125.9
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 467.9,
    y1: 112,
    x2: 467.9,
    y2: 125.9
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M493.7,93.8h-7.9c-0.8,0-1.4-0.6-1.4-1.4v-63h60.9c0.2,0,0.4,0,0.6,0.2l25.7,13.2c0.4,0.2,0.7,0.6,0.8,1.1 l3.4,28.8c0,0.1,0,0.1,0,0.2v28.8c0,0.8-0.6,1.4-1.4,1.4h-27c-0.4,0-0.7-0.2-1-0.4l-8.5-8.5c-0.3-0.3-0.6-0.4-1-0.4h-30.5"
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 531.1,
    y1: 88.1,
    x2: 488.7,
    y2: 88.1
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M492.3,10.4l-2.8,5.5c-0.3,0.7-0.7,1.3-1,2c0,0,20.4,2,45.6,11.6c0.1-0.8-0.1-1.7-0.9-2.4 c-5.7-5.3-17.6-13.5-39-17.4C493.4,9.5,492.6,9.8,492.3,10.4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M533.2,27c-5.7-5.3-17.6-13.5-39-17.4c-0.8-0.1-1.5,0.2-1.9,0.8l-2.8,5.5c-1.8,3.5-5.2,8.6-5.1,13.6l49.7-0.1 C534.2,28.6,534,27.7,533.2,27L533.2,27z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHgv);
export default __webpack_public_path__ + "static/media/hgv.f1cfb921bb0b2ae543ed5ab437855c56.svg";
export { ForwardRef as ReactComponent };